import styled, { css, keyframes } from 'styled-components';

export const Spinner = styled.div`
    position: relative;
    min-width: 5px;
`

export const keyBounce = keyframes` 
    0%, 80%, 100% {
        transform: scale(0.0);
    } 40% { 
        transform: scale(1.0);
    }
`

export interface BounceProps {
    backgroundColor?: string
}

export const Bounce1 = styled.div`
    width: 9px;
    height: 9px;
    background-color: ${(props: BounceProps) => props.backgroundColor ? props.backgroundColor : "#204078"};

    border-radius: 100%;
    display: inline-block;

    animation-delay: -0.32s;
    animation: ${keyBounce} 1.4s infinite ease-in-out both;
`;

export const Bounce2 = styled(Bounce1)`
    animation-delay: -0.16s;
`
export const Bounce3 = styled(Bounce1)`
    animation-delay: -0.32s;
`

